import effectManager from '../module/effect';

let effect = new effectManager();

/* ---------------------------------------

    -- ACTIONのスライド機能

--------------------------------------- */
export default class  actionSlideManager {
    constructor() {

        this.$container = $("#p-action-slide");
        this.$target = this.$container.find(".photo");
        this.ctrl = {
            $prev : $("#p-action-slide-arrow-prev"),
            $next : $("#p-action-slide-arrow-next")
        }
        this.pager = {
            $num : $("#p-action-slide-pager-no .current .current-num"),
            $gauge:$("#p-action-slide-pager-seekbar-gauge")
        }


        this.status = {
            current : 0,
            prevCurrent:0,
            time : 0,
        }

        this.conf = {
            NUM   : this.$target.length-1,
            PAUSE : 240,
        }


    }
    init(){


        for(let i=0; this.conf.NUM>=i; i++){
            if(i!=this.status.current) TweenMax.set(this.$target.eq(i),{x:-120+"%"})
        }

        TweenMax.set(this.pager.$gauge,{x:-101+"%"})

        this.ctrl.$next.on("click",()=>this.update("next"));


        this.ctrl.$prev.on("click",()=>this.update("prev"));


    }
    update(dir){

        // console.log("update")

        this.status.prevCurrent = this.status.current;
        this.status.time = 0;

        if(dir === "next"){
            this.status.current = this.conf.NUM>this.status.current ? this.status.current+1 : 0;

        }else{
            this.status.current = 0<this.status.current ? this.status.current-1 : this.conf.NUM;
        }

        effect.show(this.pager.$num.eq(1),"out");
        setTimeout(()=>{
            this.pager.$num.eq(1).text(this.status.current+1);
            effect.show(this.pager.$num.eq(1),"show");
        },3e2)

        TweenMax.to(this.pager.$gauge,0.4,{
            x:-101+"%",
            onComplete:()=>{
            }
        })


        this.show(dir);
        setTimeout(()=>{
            this.out(dir);
        },5e2)


    }
    show(dir){

        this.$target.eq(this.status.current).addClass("is-current");
        TweenMax.fromTo(this.$target.eq(this.status.current),0.9,
            {
                x : dir=="next"?-120+"%":120+"%",
                // opacity:0
            },
            {
                x:0+"%",
                // opacity:1,
                ease: "Power2.easeOut",
                // ease: "SlowMo.ease.config(0.5, 0.7, false)",
            });
        TweenMax.fromTo(this.$target.eq(this.status.current).children(),1.1,
            {
                x : -600+"%",
                scaleX:8,
            },
            {
                x : 0+"%",
                scaleX:1,
                // ease: Circ.easeInOut
                ease: "Power2.easeOut",
                // ease: "SlowMo.ease.config(0.5, 0.7, false)",
            });

    }
    out(dir){
        this.$target.eq(this.status.prevCurrent).removeClass("is-current");
        TweenMax.to(this.$target.eq(this.status.prevCurrent),1.1,
            {
                x:dir=="next"?120+"%":-120+"%",
                // ease: Circ.easeIn,
                ease: "Power2.easeOut",
                // delay:0.3
            });
        TweenMax.to(this.$target.eq(this.status.prevCurrent).children(),1.1,
            {
                scaleX:4,
                // ease: Circ.easeInOut,
                // delay:0.2
                ease: "Power2.easeOut",
            });

    }
    render(){
        if(Useragnt.mobile) return;
        this.status.time += 1;
        if(this.conf.PAUSE<this.status.time){
            this.update("next");
        }else{
            TweenMax.set(this.pager.$gauge,{x: -100+(this.status.time/this.conf.PAUSE*100)+"%"})
        }
    }
    resize(){

    }
}